import Button from '~/src/atoms/Button';
import tw from 'twin.macro';
import SaveforlaterIcon from '../../../public/bb2assets/images/svg/SaveIcon.svg';
import SaveforlaterClicked from '../../../public/bb2assets/images/svg/SavedIcon.svg';
import NotifyMeRed from '../../../public/bb2assets/images/svg/Notify_me_red.svg';
import { getItemFromSessionStorage } from '~/src/libs/sessionStorage';
import Label from '~/src/atoms/Label';

export const SaveForLaterButton = ({ id = null, ...rest }) => {
  const isAlreadyClicked = getItemFromSessionStorage(id) === 'sfl';
  return (
    <div className={`relative w-full h-full overflow-hidden rounded-2xs`}>
      <div className="relative z-2 w-full h-full">
        <Button
          variant="darkOnyx-outline-small"
          css={[tw`flex items-center justify-center lg:w-8 xl:w-9 h-full bg-white border hover:shadow-2 hover:cursor-pointer border-silverSurfer-800`]}
          {...rest}>
          {isAlreadyClicked ? <SaveforlaterClicked /> : <SaveforlaterIcon className={'w-5 h-5'} />}
        </Button>
      </div>
    </div>
  );
};

export const NotifyMeButton = ({ children, id = null, isLoading = false, ...rest }) => {
  const isAlreadyClicked = getItemFromSessionStorage(id) === 'notified';
  return (
    <Button
      css={[
        tw`h-full bg-white border border-rossoCorsa-500 text-rossoCorsa-500`,
        isAlreadyClicked ? tw`border-none bg-rossoCorsa-50` : tw`hover:bg-rossoCorsa-500 hover:text-white`,
        isLoading && tw`bg-rossoCorsa-50 border-none hover:bg-rossoCorsa-50 hover:border-none`,
      ]}
      {...rest}>
      {isLoading && (
        <div className="py-0.5 font-semibold text-rossoCorsa-800 ">
          {/* <Loader type="SyncLoader" color="#FFFFFF" size={5} /> */}
          Notifying...
        </div>
      )}
      {!isLoading && <>{isAlreadyClicked ? <NotifyMeRed /> : children}</>}
    </Button>
  );
};

export const NotifyMePD = ({ children, id = null, isLoading = false, stickyBttn, handleNotifyMe, ...rest }) => {
  const isAlreadyClicked = getItemFromSessionStorage(id) === 'notified';
  return (
    <Button
      css={[
        tw`border-none bg-rossoCorsa-500 text-white font-semibold xl:font-bold text-base leading-sm`,
        stickyBttn ? tw`w-40 xl:w-51.5 mr-4 py-2.5` : tw`lg:w-60 xl:w-82 mr-6 py-4.1 xl:leading-5.5`,
        isAlreadyClicked ? tw`bg-rossoCorsa-50` : tw`bg-rossoCorsa-500`,
        isLoading && tw`bg-rossoCorsa-50 border-none hover:bg-rossoCorsa-50 hover:border-none`,
      ]}
      onClick={isAlreadyClicked ? undefined : handleNotifyMe}
      {...rest}>
      {isLoading && (
        <div className="font-semibold text-white">
          {/* <Loader type="SyncLoader" color="#FFFFFF" size={5} /> */}
          Notifying...
        </div>
      )}
      {!isLoading && <>{isAlreadyClicked ? <NotifyMeRed /> : children}</>}
    </Button>
  );
};

export const SaveForLaterButtonPD = ({ id = null, stickyBttn, ...rest }) => {
  const isAlreadyClicked = getItemFromSessionStorage(id) === 'sfl';
  return (
    <Button css={[tw`flex items-center justify-center bg-white h-full border rounded-2xs w-full border border-silverSurfer-800 p-0`]} {...rest}>
      {isAlreadyClicked ? <SaveforlaterClicked /> : <SaveforlaterIcon className="w-6 h-6" />}
      {!stickyBttn && <Label className="text-base font-semibold text-darkOnyx-800 pl-2 leading-sm"> {isAlreadyClicked ? 'Saved' : 'Save for later'}</Label>}
    </Button>
  );
};
